import { render, staticRenderFns } from "./FoodsManage.vue?vue&type=template&id=67bec370&scoped=true"
import script from "./FoodsManage.vue?vue&type=script&lang=js"
export * from "./FoodsManage.vue?vue&type=script&lang=js"
import style0 from "./FoodsManage.vue?vue&type=style&index=0&id=67bec370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bec370",
  null
  
)

export default component.exports